"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
function useScrollTop(location) {
    react_1["default"].useEffect(function () {
        window.scrollTo(0, 0);
    }, [location]);
}
exports["default"] = useScrollTop;
